import React from "react";

// Types
import InputFactoryProps from "../../../types/InputFactoryProps";

// Services
import ApiService from "../../../services/ApiService";

// Components
import { IonButton, IonIcon, IonInput, IonLabel, IonToggle } from "@ionic/react";
import { eyeOffOutline, eyeOutline } from "ionicons/icons";
import { Address, Phone, Sponsors } from "../../Inputs";
import Checkbox from "../../Inputs/Checkbox";
import Color from "../../Inputs/Color";
import { DateField } from "../../Inputs/Date";
import Datetime from "../../Inputs/Datetime";
import File from "../../Inputs/File";
import Image from "../../Inputs/Image";
import ImageProfile from "../../Inputs/ImageProfile";
import Pandadoc from "../../Inputs/Pandadoc";
import PasswordNew from "../../Inputs/PasswordNew";
import RadioGroup from "../../Inputs/RadioGroup";
import Search from "../../Inputs/Search";
import Select from "../../Inputs/Select";
import Textarea from "../../Inputs/Textarea";
import Time from "../../Inputs/Time";
import TinyMCE from "../../Inputs/TinyMCE";

export default class InputFactory extends React.Component<InputFactoryProps | any, any> {
  static textareaTypes = ["textarea"];

  static radioGroupTypes = ["radiogroup"];

  static selectTypes = ["select"];

  static checkTypes = ["checkboxes"];

  static toggleTypes = ["boolean"];

  static colorTypes = ["colour", "color"];

  static fileTypes = ["file"];

  static imageTypes = ["image"];

  static pandadocTypes = ["pandadoc"];

  static jsonTypes = ["json", "array", "object"];

  static imageProfileTypes = ["image-profile"];

  static passwordNewTypes = ["password-new"];

  static addressTypes = ["address"];

  static sponsorsTypes = ["sponsors"];

  static phoneTypes = ["phone", "tel"];

  static tinyMceTypes = ["tiny-mce", "rich-text"];

  static dateTypes = ["date"];

  static timeTypes = ["time"];

  static datetimeTypes = ["datetime", "date-time"];

  static searchTypes = ["search", "filter"];

  constructor(props: any, context: any) {
    super(props, context);

    this.state = {
      options: [],
      currentType: this.props.type,
    };
  }

  render() {
    if (this.isTextarea()) return this.renderTextarea();
    if (this.isJson()) return this.renderTextarea();
    if (this.isRadioGroup()) return this.renderRadioGroup();
    if (this.isSelect()) return this.renderSelect();
    if (this.isCheckbox()) return this.renderCheckbox();
    if (this.isToggle()) return this.renderToggle();
    if (this.isFile()) return this.renderFileInput();
    if (this.isImage()) return this.renderImageInput();
    if (this.isPandadoc()) return this.renderPandadoc();
    if (this.isImageProfile()) return this.renderImageProfile();
    if (this.isPasswordNew()) return this.renderPasswordNew();
    if (this.isAddress()) return this.renderAddress();
    if (this.isSponsors()) return this.renderSponsors();
    if (this.isPhone()) return this.renderPhone();
    if (this.isTinyMCE()) return this.renderTinyMCE();
    if (this.isDate()) return this.renderDate();
    if (this.isTime()) return this.renderTime();
    if (this.isDatetime()) return this.renderDatetime();
    if (this.isSearch()) return this.renderSearch();
    if (this.isColor()) return this.renderColor();
    return this.renderInput();
  }

  componentDidMount() {
    if (this.isSelect() || this.isRadioGroup()) this.getOptions();
  }

  public renderInput() {
    const { placeholder, label, ...fieldProps } = this.props;

    let inputmode = "text";

    if (this.props.type === "number") inputmode = "numeric";
    if (this.props.type === "email") {
      inputmode = "email";
    }

    return (
      <div className={"input-factory__input__container input-factory__input__container--type-" + this.props.type}>
        {label && <IonLabel>{label}</IonLabel>}
        <IonInput
          ref={this.props.inputRef}
          //@ts-ignore
          inputmode={inputmode}
          autocapitalize={"on"}
          placeholder={this.props.attr?.placeholder ? this.props.attr?.placeholder : placeholder}
          {...fieldProps}
          type={this.state.currentType}
        />
        {this.props.type === "password" && (
          <IonButton
            size={"small"}
            fill={"clear"}
            onClick={() => {
              this.setState({
                currentType: this.state.currentType === "password" ? "text" : "password",
              });
            }}
          >
            <IonIcon slot={"icon-only"} icon={this.state.currentType === "password" ? eyeOutline : eyeOffOutline} />
          </IonButton>
        )}
      </div>
    );
  }

  public renderPasswordNew() {
    return <PasswordNew {...this.props} />;
  }

  public renderAddress() {
    return <Address {...this.props} />;
  }

  public renderSponsors() {
    return <Sponsors {...this.props} />;
  }

  public renderPhone() {
    return (
      <>
        <div style={{ width: "100%" }}>{this.props.label && <IonLabel>{this.props.label}</IonLabel>}</div>
        <Phone {...this.props} />
      </>
    );
  }

  public renderDate() {
    return (
      <>
        <div style={{ width: "100%" }}>{this.props.label && <IonLabel>{this.props.label}</IonLabel>}</div>
        <DateField {...this.props} />
      </>
    );
  }

  public renderTime() {
    return <Time {...this.props} />;
  }

  public renderDatetime() {
    return <Datetime {...this.props} />;
  }

  public renderTextarea() {
    return <Textarea {...this.props} />;
  }

  public renderTinyMCE() {
    return <TinyMCE {...this.props} />;
  }

  public renderSearch() {
    return <Search {...this.props} />;
  }

  public renderRadioGroup() {
    const { options } = this.state;
    return options && Object.keys(options).length && <RadioGroup {...this.props} options={options} />;
  }

  public renderSelect() {
    return <Select {...this.props} options={this.state.options} />;
  }

  public renderCheckbox() {
    return <Checkbox {...this.props} />;
  }

  public renderToggle() {
    return (
      <>
        {this.props.label && <IonLabel>{this.props.label}</IonLabel>}
        <IonToggle
          name={this.props.name}
          checked={this.props.value?.toString() === "1"}
          onIonChange={(e: CustomEvent) => {
            e.detail.value = e.detail.checked ? "1" : "0";
            if (this.props.onIonChange) this.props.onIonChange(e);
          }}
        />
      </>
    );
  }

  public renderFileInput() {
    return <File {...this.props} />;
  }

  public renderImageInput() {
    return <Image {...this.props} />;
  }

  public renderPandadoc() {
    return <Pandadoc {...this.props} />;
  }

  public renderImageProfile() {
    return <ImageProfile {...this.props} />;
  }

  public renderColor() {
    return <Color {...this.props} />;
  }

  protected getOptions() {
    if (this.props.optionsFrom) {
      ApiService.get(this.props.optionsFrom).then((options) => {
        this.setState({ options: options });
      });
    }

    this.setState({ options: this.props.options });
  }

  protected isTextarea(): boolean {
    return InputFactory.textareaTypes.includes(this.props.type);
  }

  protected isRadioGroup(): boolean {
    return InputFactory.radioGroupTypes.includes(this.props.type);
  }

  protected isSelect(): boolean {
    return InputFactory.selectTypes.includes(this.props.type);
  }

  protected isCheckbox(): boolean {
    return InputFactory.checkTypes.includes(this.props.type);
  }

  protected isToggle(): boolean {
    return InputFactory.toggleTypes.includes(this.props.type);
  }

  protected isFile(): boolean {
    return InputFactory.fileTypes.includes(this.props.type);
  }

  protected isImage(): boolean {
    return InputFactory.imageTypes.includes(this.props.type);
  }

  protected isPandadoc(): boolean {
    return InputFactory.pandadocTypes.includes(this.props.type);
  }

  protected isJson(): boolean {
    return InputFactory.jsonTypes.includes(this.props.type);
  }

  protected isImageProfile(): boolean {
    return InputFactory.imageProfileTypes.includes(this.props.type);
  }

  protected isPasswordNew(): boolean {
    return InputFactory.passwordNewTypes.includes(this.props.type);
  }

  protected isAddress(): boolean {
    return InputFactory.addressTypes.includes(this.props.type);
  }

  protected isSponsors(): boolean {
    return InputFactory.sponsorsTypes.includes(this.props.type);
  }

  protected isPhone(): boolean {
    return InputFactory.phoneTypes.includes(this.props.type);
  }

  protected isTinyMCE(): boolean {
    return InputFactory.tinyMceTypes.includes(this.props.type);
  }

  protected isDate(): boolean {
    return InputFactory.dateTypes.includes(this.props.type);
  }

  protected isTime(): boolean {
    return InputFactory.timeTypes.includes(this.props.type);
  }

  protected isDatetime(): boolean {
    return InputFactory.datetimeTypes.includes(this.props.type);
  }

  protected isSearch(): boolean {
    return InputFactory.searchTypes.includes(this.props.type);
  }

  protected isColor(): boolean {
    return InputFactory.colorTypes.includes(this.props.type);
  }
}
